import { apiClient } from '@/api'

export default {
  namespaced: true,
  state: () => ({
    payments:[],
    total:0,
  }),
  mutations: {
    SET_PAYMENTS(state, items) {
      state.payments = items
    },
    SET_TOTAL(state, total) {
      state.total = total
    }
  },
  actions: {
    async fetchPayments({ commit }, data) {
      const res = await apiClient('payments.get', data)
      commit('SET_PAYMENTS', res.list)
      if(res.total !== undefined){
        commit('SET_TOTAL', res.total)
      }
    },
    // Отмена платежа (делает "мягкую" отмену, флаг или статус)
    async cancelPayment({ dispatch }, data) {
      await apiClient('payments.cancel', data)
      // После отмены — обновить список
      await dispatch('fetchPayments', data.client_id)
    },
    // Возврат платежа (создает запись возврата + меняет статус исходной)
    async refundPayment({ dispatch }, data) {
      await apiClient('payments.refund', data)
      await dispatch('fetchPayments', data.client_id)
    }
  }
}